import { render, staticRenderFns } from "./alert-error.vue?vue&type=template&id=5ad06480&scoped=true&lang=pug&"
import script from "./alert-error.vue?vue&type=script&lang=js&"
export * from "./alert-error.vue?vue&type=script&lang=js&"
import style0 from "./alert-error.vue?vue&type=style&index=0&id=5ad06480&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad06480",
  null
  
)

export default component.exports